/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeightUpsertRequestDto } from './HeightUpsertRequestDto';
import {
    HeightUpsertRequestDtoFromJSON,
    HeightUpsertRequestDtoFromJSONTyped,
    HeightUpsertRequestDtoToJSON,
    HeightUpsertRequestDtoToJSONTyped,
} from './HeightUpsertRequestDto';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';
import type { WeightUpsertRequestDto } from './WeightUpsertRequestDto';
import {
    WeightUpsertRequestDtoFromJSON,
    WeightUpsertRequestDtoFromJSONTyped,
    WeightUpsertRequestDtoToJSON,
    WeightUpsertRequestDtoToJSONTyped,
} from './WeightUpsertRequestDto';

/**
 * 
 * @export
 * @interface UpdateGeneralInformationRequestDto
 */
export interface UpdateGeneralInformationRequestDto {
    /**
     * Gender
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    gender: string;
    /**
     * First name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    firstName: string;
    /**
     * Middle name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    middleName?: string;
    /**
     * Last name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    lastName: string;
    /**
     * Birth date
     * @type {Date}
     * @memberof UpdateGeneralInformationRequestDto
     */
    birthDate: Date;
    /**
     * Primary care phone
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    primaryCarePhone?: string;
    /**
     * Phone
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    phone?: string;
    /**
     * Emergency contact name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    emergencyContactName?: string;
    /**
     * Emergency contact phone
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    emergencyContactPhone?: string;
    /**
     * Patient address
     * @type {AddressDto}
     * @memberof UpdateGeneralInformationRequestDto
     */
    address?: AddressDto;
    /**
     * Patient shipping address
     * @type {AddressDto}
     * @memberof UpdateGeneralInformationRequestDto
     */
    shippingAddress?: AddressDto;
    /**
     * Weight
     * @type {WeightUpsertRequestDto}
     * @memberof UpdateGeneralInformationRequestDto
     */
    weight?: WeightUpsertRequestDto;
    /**
     * Height
     * @type {HeightUpsertRequestDto}
     * @memberof UpdateGeneralInformationRequestDto
     */
    height?: HeightUpsertRequestDto;
    /**
     * Profile image URL
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    photoUrl?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof UpdateGeneralInformationRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the UpdateGeneralInformationRequestDto interface.
 */
export function instanceOfUpdateGeneralInformationRequestDto(value: object): value is UpdateGeneralInformationRequestDto {
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    return true;
}

export function UpdateGeneralInformationRequestDtoFromJSON(json: any): UpdateGeneralInformationRequestDto {
    return UpdateGeneralInformationRequestDtoFromJSONTyped(json, false);
}

export function UpdateGeneralInformationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGeneralInformationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'gender': json['gender'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'birthDate': (new Date(json['birthDate'])),
        'primaryCarePhone': json['primaryCarePhone'] == null ? undefined : json['primaryCarePhone'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'emergencyContactName': json['emergencyContactName'] == null ? undefined : json['emergencyContactName'],
        'emergencyContactPhone': json['emergencyContactPhone'] == null ? undefined : json['emergencyContactPhone'],
        'address': json['address'] == null ? undefined : AddressDtoFromJSON(json['address']),
        'shippingAddress': json['shippingAddress'] == null ? undefined : AddressDtoFromJSON(json['shippingAddress']),
        'weight': json['weight'] == null ? undefined : WeightUpsertRequestDtoFromJSON(json['weight']),
        'height': json['height'] == null ? undefined : HeightUpsertRequestDtoFromJSON(json['height']),
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function UpdateGeneralInformationRequestDtoToJSON(json: any): UpdateGeneralInformationRequestDto {
    return UpdateGeneralInformationRequestDtoToJSONTyped(json, false);
}

export function UpdateGeneralInformationRequestDtoToJSONTyped(value?: UpdateGeneralInformationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gender': value['gender'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'birthDate': ((value['birthDate']).toISOString()),
        'primaryCarePhone': value['primaryCarePhone'],
        'phone': value['phone'],
        'emergencyContactName': value['emergencyContactName'],
        'emergencyContactPhone': value['emergencyContactPhone'],
        'address': AddressDtoToJSON(value['address']),
        'shippingAddress': AddressDtoToJSON(value['shippingAddress']),
        'weight': WeightUpsertRequestDtoToJSON(value['weight']),
        'height': HeightUpsertRequestDtoToJSON(value['height']),
        'photoUrl': value['photoUrl'],
        'isOnboarding': value['isOnboarding'],
    };
}

